/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import AuthenticatedComponent from '../utilities/AuthenticatedComponent';
import { createZipAndDownload } from '../utilities/CreateZipAndDownload';

import WithRouter from '../utilities/WithRouter';
import { setCurrentCampus, setCurrentEVData, setCurrentBatteryData } from '../actions';
import { formatBillPeriod, formatCommas, formatCost } from '../utilities/HelperFunctions';
import { initializeGraph, billPDFCallback } from '../utilities/TrendsFunctionsHelper';
import { elexity } from '../utilities/TrendsGraphHelper';
import { mapPosixToIANA } from '../utilities/SolarTrendsFunctionsHelper';
import moment from 'moment';
import 'moment-timezone';

import DatePicker from 'react-datepicker';
import Select from 'react-select';
import ProcessingAndError from '../components/ProcessingAndError';
import TrendsIcon from '../components/icons/TrendsIcon';
import icon_pdf from '../assets/icon_pdf.svg';
import { ReactComponent as ArrowIcon } from '../assets/icon_arrow.svg';
import { ReactComponent as BarIcon } from '../assets/icon_barChart.svg';
import { ReactComponent as PieIcon } from '../assets/icon_pieChart.svg';
import DownloadIcon from '../components/icons/DownloadIcon';
import StartEndTime from '../components/modals/StartEndTime';
import { current } from '@reduxjs/toolkit';

require('highcharts/modules/accessibility');
require('highcharts/modules/draggable-points');
require('highcharts/modules/exporting');
require('highcharts/modules/export-data');

const Trends = ({
  currentCampusData,
  currentCampusId,
  currentGXId,
  currentGXData,
  onGXChange,
  updateGXData,
  showMobile,
  processing,
  setProcessing,
  errorMessage,
  router,
}) => {
  const authenticatedComponent = new AuthenticatedComponent();
  const errorMessageRef = useRef(null);
  const utilityChargesRef = useRef(null);
  const usageHistoryRef = useRef(null);
  const peakDemandRef = useRef(null);
  const loadProfileRef = useRef(null);
  const weatherImpactsRef = useRef(null);

  const [billData, setBillData] = useState([]);
  const [gxOptions, setGXOptions] = useState([]);
  const [filesToZip, setFilesToZip] = useState([]);
  const [showBillGraphs, setShowBillGraphs] = useState(true);
  const [campusTimeZone, setCampusTimeZone] = useState(null);

  ////UTILITY CHARGES PIE DATA////
  const [utilityPieSeries, setUtilityPieSeries] = useState([]);
  const [demandTotal, setDemandTotal] = useState(0);
  const [energyTotal, setEnergyTotal] = useState(0);
  const [otherTotal, setOtherTotal] = useState(0);
  const [taxTotal, setTaxTotal] = useState(0);
  const [allTotal, setAllTotal] = useState(0);

  ////USAGE HISTORY PIE DATA////
  const [usageHistoryPieSeries, setUsageHistoryPieSeries] = useState([]);
  const [criticalTotal, setCriticalTotal] = useState(0);
  const [midPeakTotal, setMidPeakTotal] = useState(0);
  const [onPeakTotal, setOnPeakTotal] = useState(0);
  const [offPeakTotal, setOffPeakTotal] = useState(0);
  const [superOffPeakTotal, setSuperOffPeakTotal] = useState(0);

  ////GRAPH AND CONTROLS////
  const [activeTab, setActiveTab] = useState('utilityCharges');
  const [chartType, setChartType] = useState('bar');

  //PREV/NEXT range
  const [prevEnabled, setPrevEnabled] = useState(true);
  const [nextEnabled, setNextEnabled] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(0);
  const [rangeCount, setRangeCount] = useState(0);

  //FREQUENCY daily/monthly/weekly
  const [activeFrequency, setActiveFrequency] = useState('BILL');

  //OCCUPIED TIME
  const [activeOccupiedOption, setActiveOccupiedOption] = useState(null);

  //CALENDAR from and to dates
  const [calendarFromDate, setCalendarFromDate] = useState(null);
  const [calendarToDate, setCalendarToDate] = useState(null);

  //BILL PICKER
  const [billFromTime, setBillFromTime] = useState(null);
  const [billToTime, setBillToTime] = useState(null);

  const showFrequency = activeTab === 'peakDemand';
  const showBarPie = activeTab === 'utilityCharges' || activeTab === 'usageHistory';
  const showPrevNext =
    activeTab === 'utilityCharges' || activeTab === 'usageHistory' || activeTab === 'peakDemand';
  const showSetOccupied = activeTab === 'weatherImpacts';

  let stateObj;
  let gxParam = router.location.pathname.split('/')[3];

  useEffect(() => {
    initializeGraph(
      calendarFromDate,
      calendarToDate,
      activeFrequency,
      chartType,
      activeTab,
      currentGXId,
      billData,
      pieCallback
    );
  }, [calendarFromDate, calendarToDate]);

  function getTZAdjustedTimestamp(dateString, type) {
    if (!campusTimeZone || !dateString) {
      return null;
    }

    if (typeof dateString !== 'string' || dateString.trim() === '') {
      console.error('Invalid dateString passed to getTZAdjustedTimestamp:', dateString);
      return null;
    }

    let momentObj = moment.tz(dateString, campusTimeZone);

    if (!momentObj.isValid()) {
      console.error(`Moment failed to parse date '${dateString}' with TZ '${campusTimeZone}'.`);
      return null;
    }

    if (type === 'start') {
      return momentObj.startOf('day').valueOf();
    }

    if (type === 'end') {
      return momentObj.startOf('day').valueOf();
    }

    return momentObj.valueOf();
  }

  useEffect(() => {
    replaceUrl();
    makeGXOptions('gx');
  }, [updateGXData]);

  useEffect(() => {
    updateGXData(currentCampusId);
    setProcessing(true);

    if (
      currentGXId &&
      utilityChargesRef !== null &&
      usageHistoryRef !== null &&
      peakDemandRef !== null &&
      loadProfileRef !== null &&
      weatherImpactsRef !== null
    ) {
      authenticatedComponent.getBills(currentGXId, billCallback);
    }
  }, [currentGXId, currentCampusId]);

  useEffect(() => {
    if (billData.length > 0 && campusTimeZone && billFromTime === null) {
      const latestEndDate = billData[0].endDate;
      let defaultFromValue;
      let fromIndex;

      if (billData.length >= 12) {
        setRangeCount(12);
        setStartIndex(12);
        fromIndex = 11;
        defaultFromValue = {
          value: getTZAdjustedTimestamp(billData[11].startDate, 'start'),
          label: `${formatBillPeriod(billData[11].startDate)}`,
        };
      } else {
        fromIndex = billData.length - 1;
        setRangeCount(billData.length - 1);
        setStartIndex(billData.length - 1);
        defaultFromValue = {
          value: getTZAdjustedTimestamp(billData[billData.length - 1].startDate, 'start'),
          label: `${formatBillPeriod(billData[billData.length - 1].startDate)}`,
        };
      }

      setBillFromTime(defaultFromValue);
      setCalendarFromDate(new Date(billData[fromIndex].startDate).getTime());

      setBillToTime({
        value: getTZAdjustedTimestamp(latestEndDate, 'end'),
        label: `${formatBillPeriod(latestEndDate)}`,
      });
      setCalendarToDate(new Date(latestEndDate).getTime());
    }

    setProcessing(false);
  }, [billData, campusTimeZone]);

  useEffect(() => {
    updateIndexRange();
  }, [billFromTime, billToTime, campusTimeZone]);

  useEffect(() => {
    if (billData.length > 0) {
      let tempZip = [];

      for (var i = 0; i < billData.length; i++) {
        tempZip.push(billData[i].pdfDownloadUrl);
      }

      setFilesToZip(tempZip);
    }
  }, [billData]);

  function replaceUrl() {
    if ((gxParam === undefined || gxParam !== currentGXId) && currentGXId !== null) {
      window.history.replaceState(stateObj, '', `/trends/${currentCampusId}/${currentGXId}`);
    }
  }

  const updateIndexRange = () => {
    if (billFromTime === null || billToTime === null || campusTimeZone === null) {
      return;
    }

    let newStartIndex = -1;
    let newEndIndex = -1;

    for (let i = 0; i < billData.length; i++) {
      const dataStartTime = getTZAdjustedTimestamp(billData[i].startDate, 'start');
      const dataEndTime = getTZAdjustedTimestamp(billData[i].endDate, 'end');

      if (dataStartTime === billFromTime.value) {
        newStartIndex = i;
      }

      if (dataEndTime === billToTime.value) {
        newEndIndex = i;
      }

      if (newStartIndex !== -1 && newEndIndex !== -1) {
        break;
      }
    }

    if (newStartIndex !== -1 && newEndIndex !== -1) {
      const newRangeCount = newStartIndex - newEndIndex + 1;

      setStartIndex(newStartIndex);
      setEndIndex(newEndIndex);
      setRangeCount(newRangeCount);
    }

    initializeGraph(
      billFromTime.value,
      billToTime.value,
      activeFrequency,
      chartType,
      activeTab,
      currentGXId,
      billData,
      pieCallback
    );
  };

  function billCallback(data) {
    setBillFromTime(null);
    setBillToTime(null);

    if (data && data.energyBills.length > 0) {
      setBillData(data.energyBills);

      const rawTimeZoneCode = data.timezoneCode;

      if (rawTimeZoneCode) {
        const ianaCode = mapPosixToIANA(rawTimeZoneCode);
        if (ianaCode && ianaCode !== campusTimeZone) {
          setCampusTimeZone(ianaCode);
        }
      }

      elexity.gx.trends.graphSubTitle = `${currentCampusData.campusDescription.longCampusDisplayName} - ${data.gridInterconnectDescription.longGridInterconnectDisplayName}`;

      setProcessing(false);
    } else {
      setBillData([]);
    }
  }

  function pieCallback(data) {
    if (activeTab == 'utilityCharges') {
      setUtilityPieSeries(data.tempSeries);
      setDemandTotal(data.demandTotal);
      setEnergyTotal(data.energyTotal);
      setOtherTotal(data.otherTotal);
      setTaxTotal(data.taxTotal);
      setAllTotal(data.allTotal);
    } else if (activeTab === 'usageHistory') {
      setUsageHistoryPieSeries(data.tempSeries);
      setCriticalTotal(data.criticalTotal);
      setOnPeakTotal(data.onPeakTotal);
      setMidPeakTotal(data.midPeakTotal);
      setOffPeakTotal(data.offPeakTotal);
      setSuperOffPeakTotal(data.superOffPeakTotal);
    }
  }

  const billFromArray = () => {
    if (!campusTimeZone || billToTime === null) return [];

    let tempAllOptions = billData;
    let tempOptions = [];

    for (let i = 0; i < tempAllOptions.length; i++) {
      let fromTime = getTZAdjustedTimestamp(tempAllOptions[i].startDate, 'start');

      if (fromTime <= billToTime.value) {
        tempOptions.push({
          value: fromTime,
          label: `${formatBillPeriod(tempAllOptions[i].startDate)}`,
        });
      }
    }

    return tempOptions;
  };

  const billToArray = () => {
    if (!campusTimeZone || billFromTime === null) return [];

    let tempAllOptions = billData;
    let tempOptions = [];

    for (let i = 0; i < tempAllOptions.length; i++) {
      let fromTime = getTZAdjustedTimestamp(tempAllOptions[i].startDate, 'start');

      if (fromTime >= billFromTime.value) {
        tempOptions.push({
          value: getTZAdjustedTimestamp(tempAllOptions[i].endDate, 'end'),
          label: `${formatBillPeriod(tempAllOptions[i].endDate)}`,
        });
      }
    }

    return tempOptions;
  };

  function makeGXOptions(type) {
    if (currentGXData && currentGXData.gridInterconnects) {
      if (type === 'gx') {
        setGXOptions(
          currentGXData.gridInterconnects.map((gx, index) => (
            <option
              key={`gx-option-${index}`}
              value={gx.gridInterconnectDescription.gridInterconnectEntityKey}
              selected={gx.gridInterconnectDescription.gridInterconnectEntityKey === currentGXId}
            >
              {gx.gridInterconnectDescription.longGridInterconnectDisplayName}
            </option>
          ))
        );
      }
    }
  }

  ////HANDLERS////
  function handleCalendarDateChange(date, name) {
    if (name === 'from') {
      setCalendarFromDate((prevDate) => date.getTime());
    } else {
      setCalendarToDate((prevDate) => date.getTime());
    }
  }

  function handleActiveTab(name) {
    setActiveTab(name);
    setChartType('bar');
    setActiveFrequency('BILL');

    if (name === 'loadProfile') {
      initializeGraph(
        calendarFromDate,
        calendarToDate,
        activeFrequency,
        'bar',
        name,
        currentGXId,
        billData,
        pieCallback
      );
      return;
    }

    initializeGraph(
      billFromTime.value,
      billToTime.value,
      'BILL',
      'bar',
      name,
      currentGXId,
      billData,
      pieCallback
    );
  }

  function handleFrequencyChange(type) {
    setActiveFrequency((prevFrequency) => type);
    initializeGraph(
      billFromTime.value,
      billToTime.value,
      type,
      chartType,
      activeTab,
      currentGXId,
      billData,
      pieCallback
    );
  }

  function handleChartTypeChange(e) {
    setChartType(e.target.value);
    initializeGraph(
      billFromTime.value,
      billToTime.value,
      activeFrequency,
      e.target.value,
      activeTab,
      currentGXId,
      billData,
      pieCallback
    );
  }

  function handleSkipRange(type) {
    if (!campusTimeZone) return;

    let newFromBill;
    let newToBill;

    let lastBill = billData.length;
    let toCap = 0;
    let fromCap = lastBill - 1;

    if (type === 'prev') {
      newFromBill = billData[startIndex + rangeCount];
      newToBill = billData[endIndex + rangeCount];

      setPrevEnabled((prevState) => {
        return startIndex + rangeCount + rangeCount < fromCap;
      });
      setNextEnabled((prevState) => {
        return endIndex + rangeCount + rangeCount > toCap;
      });
    } else {
      newFromBill = billData[startIndex - rangeCount];
      newToBill = billData[endIndex - rangeCount];

      setPrevEnabled((prevState) => {
        return startIndex - rangeCount - rangeCount <= fromCap;
      });
      setNextEnabled((prevState) => {
        return endIndex - rangeCount - rangeCount >= toCap;
      });
    }

    setBillFromTime({
      value: getTZAdjustedTimestamp(newFromBill.startDate, 'start'),
      label: `${formatBillPeriod(newFromBill.startDate)}`,
    });

    setBillToTime({
      value: getTZAdjustedTimestamp(newToBill.endDate, 'end'),
      label: `${formatBillPeriod(newToBill.endDate)}`,
    });
  }

  const handleZipDownload = () => {
    setProcessing(true);
    createZipAndDownload(currentGXId, currentGXId, filesToZip, setProcessing);
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      height: '28px',
      minHeight: '28px',
    }),
    valueContainer: (base) => ({
      ...base,
      height: '28px',
      padding: '0 8px',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: '28px',
    }),
  };

  return (
    <TrendsSection className={showMobile ? 'mobile' : 'desktop'}>
      <div className={showMobile ? 'header-container mobile' : 'header-container'}>
        <div className="header">
          <TrendsIcon
            backgroundFill="none"
            fillColor="none"
            strokeColor={'#02222B'}
            strokeWidth={2.75}
            width="18px"
          />
          <h1>Trends</h1>
        </div>
      </div>

      <section className="trends-section">
        <ProcessingAndError
          processing={processing}
          errorMessage={errorMessage}
          errorMessageRef={errorMessageRef}
        />

        <div className="gx-menu">
          <select name="current-gx" onChange={(e) => onGXChange(e.target.value)}>
            {gxOptions}
          </select>
        </div>

        <div className="static-graph-container">
          {billData.length > 0 ? (
            <>
              <div className="chart-nav">
                <div className="tabs">
                  {showBillGraphs && (
                    <>
                      <div
                        className={
                          activeTab === 'utilityCharges'
                            ? 'utilityCharges active'
                            : 'utilityCharges'
                        }
                        onClick={() => handleActiveTab('utilityCharges')}
                      >
                        Utility Charges
                      </div>

                      <div
                        className={
                          activeTab === 'usageHistory' ? 'usageHistory active' : 'usageHistory'
                        }
                        onClick={() => handleActiveTab('usageHistory')}
                      >
                        Usage History
                      </div>
                    </>
                  )}

                  <div
                    className={activeTab === 'peakDemand' ? 'peakDemand active' : 'peakDemand'}
                    onClick={() => handleActiveTab('peakDemand')}
                  >
                    Peak Demand
                  </div>

                  <div
                    className={activeTab === 'loadProfile' ? 'loadProfile active' : 'loadProfile'}
                    onClick={() => handleActiveTab('loadProfile')}
                  >
                    Load Profile
                  </div>

                  {/* <div
                                    className={activeTab === "weatherImpacts" ? "weatherImpacts active" : "weatherImpacts"}
                                    onClick={() => handleActiveTab("weatherImpacts")}
                                >
                                    Weather Impacts
                                </div> */}
                </div>
              </div>

              <div className="active-chart-container">
                <div className="chart-options">
                  {activeTab === 'loadProfile' || activeTab === 'weatherImpacts' ? (
                    <div className="controls-container">
                      <div className="date-input-container">
                        <DatePicker
                          selected={calendarFromDate}
                          onChange={(date) => handleCalendarDateChange(date, 'from')}
                        />
                      </div>

                      <p>to</p>

                      <div className="date-input-container">
                        <DatePicker
                          selected={calendarToDate}
                          onChange={(date) => handleCalendarDateChange(date, 'to')}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="controls-container">
                      <Select
                        className="no-arrow"
                        name="from-bill-picker"
                        value={billFromTime}
                        onChange={setBillFromTime}
                        options={billFromArray()}
                        styles={customStyles}
                      />
                      <p>to</p>
                      <Select
                        className="no-arrow"
                        name="to-bill-picker"
                        value={billToTime}
                        onChange={setBillToTime}
                        options={billToArray()}
                        styles={customStyles}
                      />
                    </div>
                  )}

                  {showPrevNext && (
                    <div className="controls-container">
                      <div className="control-buttons">
                        <button
                          id="prev"
                          className="prev"
                          onClick={() => handleSkipRange('prev')}
                          disabled={!prevEnabled}
                        >
                          <ArrowIcon />
                          <p>Prev</p>
                        </button>
                        <button
                          id="next"
                          className="next"
                          onClick={() => handleSkipRange('next')}
                          disabled={!nextEnabled}
                        >
                          <p>Next</p>
                          <ArrowIcon />
                        </button>
                      </div>
                    </div>
                  )}

                  {showBarPie && (
                    <div className="controls-container">
                      <div className="chart-select">
                        {chartType === 'bar' ? (
                          <BarIcon width={18} height={18} />
                        ) : (
                          <PieIcon width={18} height={18} />
                        )}

                        <select
                          className="chart-type"
                          onChange={(e) => handleChartTypeChange(e)}
                          value={chartType}
                        >
                          <option value="bar">Bar</option>
                          <option value="pie">Pie</option>
                        </select>
                      </div>
                    </div>
                  )}

                  {showFrequency && (
                    <div className="controls-container">
                      <div className="control-buttons">
                        <button
                          id="daily"
                          className={activeFrequency === 'DAILY' ? 'frequency active' : 'frequency'}
                          onClick={() => handleFrequencyChange('DAILY')}
                        >
                          Daily
                        </button>

                        <button
                          id="weekly"
                          className={
                            activeFrequency === 'WEEKLY' ? 'frequency active' : 'frequency'
                          }
                          onClick={() => handleFrequencyChange('WEEKLY')}
                        >
                          Weekly
                        </button>

                        <button
                          id="bill"
                          className={activeFrequency === 'BILL' ? 'frequency active' : 'frequency'}
                          onClick={() => handleFrequencyChange('BILL')}
                        >
                          By Bill
                        </button>
                      </div>
                    </div>
                  )}

                  {showSetOccupied && (
                    <div className="controls-container">
                      <button
                        id="occupied"
                        className={
                          activeOccupiedOption === 'occupied'
                            ? 'occupied-option active'
                            : 'occupied-option'
                        }
                        onClick={() =>
                          activeOccupiedOption === 'occupied'
                            ? setActiveOccupiedOption(null)
                            : setActiveOccupiedOption('occupied')
                        }
                      >
                        Set Occupied Time
                      </button>

                      <button
                        id="unoccupied"
                        className={
                          activeOccupiedOption === 'unoccupied'
                            ? 'occupied-option active'
                            : 'occupied-option'
                        }
                        onClick={() =>
                          activeOccupiedOption === 'unoccupied'
                            ? setActiveOccupiedOption(null)
                            : setActiveOccupiedOption('unoccupied')
                        }
                      >
                        All Day Unoccupied
                      </button>
                    </div>
                  )}
                </div>

                {showSetOccupied && activeOccupiedOption === 'occupied' && (
                  <div className="occupied-options">
                    <div className="start-end-weekday">
                      <p>Set Weekday Occupied Time</p>
                      <StartEndTime
                        handleChange={() => console.log('this changed time')}
                        index="0"
                        selectedFromHour="6"
                        selectedFromMin="00"
                        selectedToHour="14"
                        selectedToMin="00"
                      ></StartEndTime>
                    </div>

                    <div className="start-end-weekend">
                      <p>Set Weekend Occupied Time</p>
                      <StartEndTime
                        handleChange={() => console.log('this changed time')}
                        index="1"
                        selectedFromHour="6"
                        selectedFromMin="00"
                        selectedToHour="14"
                        selectedToMin="00"
                      >
                        Weekend
                      </StartEndTime>
                    </div>
                  </div>
                )}

                {activeTab === 'utilityCharges' && (
                  <div className={chartType === 'pie' ? 'graph-container pie' : 'graph-container'}>
                    <div
                      id="utilityChargesGraph"
                      className={
                        activeTab === 'utilityCharges' ? 'staticGraph' : 'hidden staticGraph'
                      }
                      ref={utilityChargesRef}
                    ></div>

                    {chartType === 'pie' && activeTab === 'utilityCharges' && (
                      <>
                        <table>
                          <thead>
                            <tr className="table-cell">
                              <th>Charges</th>
                              <th>Total</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr className="table-cell">
                              <td>Demand</td>
                              <td>{demandTotal}</td>
                            </tr>
                            <tr className="table-cell">
                              <td>Energy</td>
                              <td>{energyTotal}</td>
                            </tr>
                            <tr className="table-cell">
                              <td>Tax</td>
                              <td>{taxTotal}</td>
                            </tr>
                            <tr className="table-cell">
                              <td>Other</td>
                              <td>{otherTotal}</td>
                            </tr>
                          </tbody>
                        </table>
                      </>
                    )}
                  </div>
                )}

                {activeTab === 'usageHistory' && (
                  <div
                    className={
                      chartType === 'pie' ? 'graph-container pie active' : 'graph-container'
                    }
                  >
                    <div
                      id="usageHistoryGraph"
                      className={
                        activeTab === 'usageHistory' ? 'staticGraph' : 'hidden staticGraph'
                      }
                      ref={usageHistoryRef}
                    ></div>

                    {chartType === 'pie' && activeTab === 'usageHistory' && (
                      <>
                        <table>
                          <thead>
                            <tr className="table-cell">
                              <th>Charges</th>
                              <th>Total</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr className="table-cell">
                              <td>Critical Peak</td>
                              <td>{criticalTotal}</td>
                            </tr>
                            <tr className="table-cell">
                              <td>On Peak</td>
                              <td>{onPeakTotal}</td>
                            </tr>
                            <tr className="table-cell">
                              <td>Mid Peak</td>
                              <td>{midPeakTotal}</td>
                            </tr>
                            <tr className="table-cell">
                              <td>Off Peak</td>
                              <td>{offPeakTotal}</td>
                            </tr>
                            <tr className="table-cell">
                              <td>Super Off Peak</td>
                              <td>{superOffPeakTotal}</td>
                            </tr>
                          </tbody>
                        </table>
                      </>
                    )}
                  </div>
                )}

                {activeTab === 'peakDemand' && (
                  <div
                    id="peakDemandGraph"
                    className={activeTab === 'peakDemand' ? 'staticGraph' : 'hidden staticGraph'}
                    ref={peakDemandRef}
                  ></div>
                )}

                {activeTab === 'loadProfile' && (
                  <div
                    id="loadProfileGraph"
                    className={activeTab === 'loadProfile' ? 'staticGraph' : 'hidden staticGraph'}
                    ref={loadProfileRef}
                  ></div>
                )}

                {activeTab === 'weatherImpacts' && (
                  <div
                    id="weatherImpactsGraph"
                    className={
                      activeTab === 'weatherImpacts' ? 'staticGraph' : 'hidden staticGraph'
                    }
                    ref={weatherImpactsRef}
                  ></div>
                )}
              </div>
            </>
          ) : (
            <div className="graph-empty-state">
              <TrendsIcon
                backgroundFill="none"
                fillColor="none"
                strokeColor={'#02222B'}
                strokeWidth={2.75}
                width="18px"
              />
              <p>There is no trends data for you at this time.</p>
            </div>
          )}
        </div>

        <div className="bill-analysis-container">
          {billData.length !== 0 ? (
            <>
              <div className="subheader">
                <p className="subhead">Utility Bills</p>
                <button onClick={() => handleZipDownload()}>
                  <DownloadIcon
                    backgroundFill="#047290"
                    strokeColor="#FFFFFF"
                    strokeWidth={2}
                    width="18px"
                  />
                  Download All
                </button>
              </div>

              <div className="bill-table">
                <table>
                  <thead>
                    <tr>
                      <th>Start Period</th>
                      <th>End Period</th>
                      <th>kWh</th>
                      <th>Total $</th>
                      <th>Download</th>
                    </tr>
                  </thead>

                  <tbody>
                    {billData.length !== 0 &&
                      billData.map((item, index) => (
                        <tr key={`bill-${index}`}>
                          <td>{formatBillPeriod(item.startDate)}</td>
                          <td>{formatBillPeriod(item.endDate)}</td>
                          <td>{formatCommas(item.energykWh, 'kWh')}</td>
                          <td>{formatCost(item.totalCost)}</td>
                          <td className="bill-download">
                            <button
                              id="pdf-bill-button"
                              onClick={() =>
                                authenticatedComponent.generatePDFBill(
                                  currentGXId,
                                  item.pdfDownloadUrl,
                                  `${formatBillPeriod(item.startDate)} - ${formatBillPeriod(item.endDate)}_${currentGXId}_bill`,
                                  billPDFCallback
                                )
                              }
                            >
                              <img src={icon_pdf} alt="PDF file type icon" width="33" height="37" />
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className="no-data">
              To enable tracking of your utility bills please send a request to{' '}
              <a href="mailto:support@elexity.io">support@elexity.io</a>.
            </div>
          )}
        </div>
      </section>
    </TrendsSection>
  );
};

const TrendsSection = styled.section`
  height: 100vh;
  overflow: auto;

  h3 {
    font-size: 16px;
  }

  p {
    margin: 0;

    &.subhead {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .trends-section {
    display: flex;
    flex-flow: column;
    row-gap: 24px;

    .gx-menu {
      select {
        padding: 10px 28px 10px 16px;
      }
    }

    .active-chart-container,
    .bill-analysis-container {
      background: white;
      border-radius: 0 12px 12px 12px;
      box-shadow: 0px 2px 6px #02222b14;
      padding: 20px 24px 24px;
    }

    .bill-analysis-container {
      margin-bottom: 24px;

      .subheader {
        align-items: center;
        display: flex;
        justify-content: space-between;
      }
    }

    .static-graph-container .graph-empty-state {
      align-items: center;
      display: flex;
      gap: 12px;
      justify-content: center;
      padding: 26px 24px 24px;
    }

    .active-chart-container {
      display: flex;
      flex-direction: column;
      gap: 24px;

      .chart-options {
        display: flex;
        flex-flow: row wrap;
        gap: 24px;

        .controls-container {
          align-items: center;
          display: flex;
          gap: 6px;
          justify-content: center;

          input {
            background-size: 18px 18px;
            border: 1px solid #c2d0d1;
            color: #02222b;
            font-size: 14px;
            font-weight: 600;
            padding: 6px 10px 6px 40px;
            width: 140px;
          }

          select {
            border: none;
            box-shadow: unset;
            text-align: center;
          }

          .chart-select {
            align-items: center;
            background: white;
            border: 1px solid #c2d0d1;
            border-radius: 4px;
            display: flex;
            justify-content: space-between;
            padding: 4px 6px;

            select {
              background-color: transparent;
              margin-right: -10px;
              padding: 0 34px 0 6px;
            }
          }

          .no-arrow {
            & > div:first-of-type {
              border: 1px solid #c2d0d1;
            }

            svg {
              fill: #02222b;
              stroke: #02222b;
            }
          }

          .control-buttons {
            display: flex;
            gap: 6px;
          }

          button {
            align-items: center;
            background: white;
            border: 1px solid #c2d0d1;
            border-radius: 4px;
            color: #02222b75;
            cursor: pointer;
            display: flex;
            font-size: 14px;
            font-weight: 400;
            gap: 6px;
            justify-content: center;
            padding: 4px;
            transition: ease-in-out all 250ms;

            &.prev,
            &.next {
              color: #02222b;
              width: 72px;

              svg {
                height: 16px;
                width: 16px;
                path,
                line {
                  stroke: #02222b;
                }
              }

              &:disabled {
                cursor: unset;
                opacity: 0.5;
              }
            }

            &.prev svg {
              transform: rotate(180deg);
            }

            &.occupied-option {
              width: 150px;
            }

            &.frequency {
              width: 85px;
            }

            &.frequency.active,
            &.occupied-option.active {
              background: #f7931e50;
              border: 1px solid #f7931e;
              color: #02222b;
              font-weight: 600;
            }
          }
        }
      }

      .occupied-options {
        align-items: center;
        display: flex;
        flex-flow: row wrap;
        gap: 24px;

        .start-end-weekday,
        .start-end-weekend,
        div.time-container {
          align-items: center;
          display: flex;
          justify-content: center;
          flex-flow: unset;
          gap: 12px;
        }

        /*TODO: redesign time start/end component*/
        div.time-container {
          align-items: center;
          border: 1px solid #c2d0d150;
          border-radius: 8px;
          display: flex;
          gap: 6px;
          height: 30px;
          justify-content: center;
          padding: 3px 6px;
          width: unset;

          label {
            display: none;
          }

          .time-input-container {
            margin: 0;

            select {
              background: unset;
              border: none;
              font-size: 14px;
              padding: 5px 10px;
            }

            img {
              display: none;
            }
          }

          .start-time-container {
            align-items: center;
            display: flex;
            gap: 12px;

            &::after {
              content: 'to';
              color: #62797e;
            }
          }
        }
      }

      .staticGraph {
        height: 500px;
      }

      .hidden {
        display: none;
        height: 0;
      }

      .graph-container.pie {
        align-items: center;
        display: flex;
        justify-content: center;
      }

      .graph-container.pie table,
      .graph-container.pie div {
        width: 50%;
      }

      .graph-container.pie table {
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;

        thead {
          border-bottom: 1px solid #c2d0d1;
        }

        tr.table-cell {
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          width: 25vw;
        }
      }
    }

    .bill-table {
      max-height: 500px;
      overflow: hidden;
      overflow-y: scroll;

      table {
        background: white;
        border-collapse: separate;
        border-radius: 12px;
        border-spacing: 0 12px;
        width: 100%;

        th {
          border-bottom: 2px solid #c2d0d1;
          text-align: left;
          width: 20%;
        }

        th:last-of-type {
          width: 100px !important;
        }

        th:nth-of-type(n + 2),
        td:nth-of-type(n + 2) {
          text-align: center;

          button {
            justify-content: center;
          }
        }

        tr {
          height: 46px;

          &:last-of-type td {
            border-bottom: none;
          }
        }

        thead {
          background: white;
          position: sticky;
          top: 0;
          z-index: 99;
        }

        thead,
        td:first-of-type {
          color: #02222b;
          font-size: 14px;
          font-weight: 500;
        }

        td {
          color: #02222b;
          font-size: 14px;
          font-weight: 500;

          button {
            align-items: center;
            background: white;
            border: none;
            border-radius: 8px;
            color: white;
            cursor: pointer;
            display: flex;
            font-family: 'Inter', Arial, Helvetica, sans-serif;
            font-size: 14px;
            font-weight: 600;
            margin: 0 auto;

            img {
              transition: ease-in-out all 250ms;
            }

            &:hover img {
              opacity: 0.5;
              transition: ease-in-out all 250ms;
            }
          }
        }
      }
    }

    .no-data {
      border-radius: 8px;
      padding: 24px;
      text-align: center;
      a {
        background: none;
        color: #02222b;
        padding: 0;
        text-decoration: underline;
        transition: ease-in-out all 250ms;
        &:hover {
          background: none;
          color: #02be7f;
          padding: 0;
          transition: ease-in-out all 250ms;
        }
      }
    }
  }
`;

const mapStateToProps = (state) => {
  return {
    currentCampusId: state.currentCampusId,
    currentEVData: state.currentEVData,
    currentBatteryData: state.currentBatteryData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentCampus: (campusId) => {
      dispatch(setCurrentCampus(campusId));
    },
    setCurrentEVData: (evData) => {
      dispatch(setCurrentEVData(evData));
    },
    setCurrentBatteryData: (batteryData) => {
      dispatch(setCurrentBatteryData(batteryData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Trends));
